import Lottie from 'react-lottie';
import animationData from '../lotties/no-data.json';

const NoData = () => {
  const defaultOptions = {
      loop: true,
      autoplay: true,
      animationData: animationData,
      rendererSettings: {
        preserveAspectRatio: "xMidYMid slice"
      }
    }
  
  return (
    <>
      <div className="mx-auto bg-gray-200 bg-opacity-80 rounded-lg mt-36">
        <Lottie
          options={defaultOptions}
          width={300}
          height={300}
        />
        <p className="text-2xl py-1.5 text-center font-medium text-indigo-default">No Data</p>
      </div>
    </>        
  )
}

export default NoData